/**
 * @description status:number;//状态枚举 1新建  2:编辑中  3 测试中  4 已发布 + 活动未生效（等待生效）
 * @description 5：已发布 + 生效中 6：已发布 + 已结束（手动停止）7：已发布 + 已结束（到期停止）
 *
 */
import editting from '@/assets/activity/editting.svg';
import effected from '@/assets/activity/effected.svg';
import end from '@/assets/activity/end.svg';
import publish from '@/assets/activity/publish.svg';
import testing from '@/assets/activity/testing.svg';
import unEffect from '@/assets/activity/uneffect.svg';
import { Activity } from '@/types/activity';
import { Template } from '@/types/template';
export const activityStatus = {
  1: {
    value: 1,
    text: '新建',
    icon: '',
    desc: '活动刚新建'
  },
  2: {
    value: 2,
    text: '编辑中',
    icon: editting,
    desc: '活动正在编辑中'
  },
  3: {
    value: 3,
    text: '测试中',
    icon: testing,
    desc: '活动正在测试中'
  },
  4: {
    value: 4,
    text: '发布中', //可使用灰度发布功能
    icon: publish,
    desc: '活动正在发布中'
  },
  5: {
    value: 5,
    text: '未生效',
    icon: unEffect,
    desc: '已发布 + 活动未生效（等待生效）'
  },
  6: {
    value: 6,
    text: '已生效',
    icon: effected,
    desc: '已发布 + 生效中'
  },
  7: {
    value: 7,
    text: '已结束',
    icon: end,
    desc: '已发布 + 活动已结束（手动停止） '
  },
  8: {
    value: 8,
    text: '已结束',
    icon: end,
    desc: '已发布 + 活动已结束（到期停止） '
  }
};

export const isOldVersion = (activity: Activity.IInfo | Template.IInfo): boolean => {
  return activity.fromVersion === 1 ? true : false;
};
//前往本活动
export const activityJump = (activity: Activity.IInfo) => {
  if (isOldVersion(activity)) {
    window.open('/recommend/op/editFlow?id=' + activity.id);
  } else {
    window.open('/smart/activity/flow/' + activity.id);
  }
};
//前往该活动的副本
export const activityUpdateJump = (activity: Activity.IInfo) => {
  if (isOldVersion(activity)) {
    window.open('/recommend/op/editFlow?id=' + activity.updateVersionId);
  } else {
    window.open('/smart/activity/flow/' + activity.updateVersionId);
  }
};
//前往该副本活动的原活动
export const activityOriginJump = (activity: Activity.IInfo) => {
  if (isOldVersion(activity)) {
    window.open('/recommend/op/editFlow?id=' + activity.originVersionId);
  } else {
    window.open('/smart/activity/flow/' + activity.originVersionId);
  }
};
